export const HeaderBotList = () => {
  return (
    <div className="flex-items-center">
      <div className="!text-[28px] md:!text-[32px] mb-3 font-semibold ">
        Bot List
      </div>
    </div>
  );
};
